import React, { ReactNode, useMemo } from "react";
import classNames from "classnames";
import styles from "./LayoutSm.module.scss";
import { FixBrand } from "../fix-brand";
import FixBackButton from "@/elements-react/fix-back-button";
import { LayoutContext } from "./LayoutContext";
import { LayoutStyleTypes } from "@/util-react/layout.tsx";

type Props = {
  children: React.ReactNode;
};

export function LayoutSmContainer({ children }: Props) {
  const renderSection = ({ segment, title, content }: { segment: string; title?: string; content: () => React.ReactNode }) => (
    <div className={classNames(styles["segment"], styles[segment])}>
      {title && <div className={styles["title"]}>{title}</div>}
      <div className={styles["content"]}>{content()}</div>
    </div>
  );

  const renderHeadMain = () => (
    <div className={classNames(styles["head"], styles["main"])}>
      <FixBrand />
    </div>
  );

  const renderHeadStack = ({ title, onBack }: { title: string; onBack: () => void }) => (
    <div className={classNames(styles["head"], styles["stack"])}>
      <FixBackButton onClick={onBack} />
      <div className={styles["title"]}>{title}</div>
    </div>
  );

  const renderHeadLg = ({ onClose }: { onClose: () => void }) => (
    <div className={classNames(styles["head"], styles[LayoutStyleTypes.TYPE_LG])}>
      <FixBrand />
    </div>
  );

  const renderDelimiter = () => <div className={styles["delimiter"]} />;

  const contextValue = {
    renderSection,
    renderHeadMain,
    renderHeadStack,
    renderHeadLg,
    renderDelimiter,
  };

  return (
    <LayoutContext.Provider value={contextValue}>
      <div className={styles["fadeIn"]}>{children}</div>
    </LayoutContext.Provider>
  );
}
